
export function setKeyValue(key, value) {
    window.localStorage.setItem(key, value);
}

export function getKey(key) {
    return window.localStorage.getItem(key);
}

export function setKeyValueWithTtl(key, value, ttl) {
    const now = new Date();

    const item = {
        value: value,
        expiry: now.getTime() + ttl
    };

    window.localStorage.setItem(key, JSON.stringify(item));
}

export function getKeyTtl(key) {
    const itemAsString = window.localStorage.getItem(key);
    if (!itemAsString) {
        return null;
    }

    const item = JSON.parse(itemAsString);
    const now = new Date();

    if (now.getTime() > item.expiry) {
        window.localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

